import React from 'react'
import {css} from '@emotion/core'

const WEBP_TYPE = 'image/webp'

interface IPicture {
  pngSrc?: string
  webpSrc?: string
  alt?: string
  className?: string
}

const Picture: React.FunctionComponent<IPicture> = ({pngSrc, webpSrc, alt, className}) => (
  <picture>
    {webpSrc && <source srcSet={webpSrc} type={WEBP_TYPE} />}
    <img className={className} src={pngSrc} alt={alt} />
  </picture>
)

export default Picture
